module.exports = __webpack_public_path__ + "static/img/logo.8121a7f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpeg
// module id = wHkt
// module chunks = 15